import React, { Component } from 'react';
import { Provider } from 'react-redux';
import store from './store';
import MainContainer from './styled/MainContainer';
import MainBackground from './components/MainBackground';
import Router from './components/Router'

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <MainContainer>
          <MainBackground />
          <Router />
        </MainContainer>
      </Provider>
    );
  }
}

export default App;
